const RoutineRoot = 'new-routines';

export const routinesPaths = {
  root: RoutineRoot,
  new: `${RoutineRoot}/new`,
  edit: `${RoutineRoot}/:routineId/edit`,
};
